var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"friend"},[_c('h3',{staticClass:"username"},[_vm._v(" "+_vm._s(_vm.user.username)+" ")])]),(_vm.$store.getters.areFriends(_vm.user.username))?_c('button',{on:{"click":_vm.removeFriend}},[_vm._v(" unfriend ❌ ")]):_c('button',{on:{"click":_vm.addFriend}},[_vm._v(" friend ➕ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }